import '@lottiefiles/lottie-player';
import {create} from '@lottiefiles/lottie-interactivity';

document.addEventListener('DOMContentLoaded', () => {
	const players = document.querySelectorAll('.lottie-animation');

	const checkInitialVisibility = el => {
		if (!el.offsetParent) {
			return false;
		}
		const rect = el.getBoundingClientRect();
		const viewportHeight = window.innerHeight;
		const elementHeight = rect.height || el.offsetHeight || el.clientHeight || 0;
		if (elementHeight === 0) {
			return false;
		}

		const visibleTop = Math.max(0, rect.top);
		const visibleBottom = Math.min(viewportHeight, rect.bottom);
		const visibleHeight = Math.max(0, visibleBottom - visibleTop);
		const visibilityRatio = visibleHeight / elementHeight;

		return visibilityRatio >= 0.3;
	};

	const playSafely = lottiePlayer => {
		if (lottiePlayer._lottie && lottiePlayer._lottie.currentFrame !== undefined) {
			lottiePlayer.play();
		} else {
			requestAnimationFrame(() => playSafely(lottiePlayer));
		}
	};

	if (players.length > 0) {
		players.forEach((player, i) => {
			const lottiePlayers = player.querySelectorAll('.lottie-animation__wrapper > .lottie-animation__element');

			lottiePlayers.forEach((lottiePlayer, j) => {
				const wrapper = lottiePlayer.parentElement;
				const containerClass = `lottie-container-${ i }-${ j }`;
				const playerClass = `lottie-player-${ i }-${ j }`;

				wrapper.classList.add(containerClass);
				lottiePlayer.classList.add(playerClass);

				const isLoop = lottiePlayer.hasAttribute('loop');
				const isAutoplay = lottiePlayer.hasAttribute('autoplay');

				if (isLoop) {
					lottiePlayer.setAttribute('loop', '');
				}
				if (isAutoplay) {
					lottiePlayer.setAttribute('autoplay', '');
				}

				const handleLoaded = () => {
					requestAnimationFrame(() => {
						const isVisible = checkInitialVisibility(lottiePlayer);

						if (player.classList.contains('lottie-animation--scroll')) {
							create({
								mode: 'scroll',
								player: `.${ playerClass }`,
								container: `.${ containerClass }`,
								actions: [
									{
										visibility: [0, 1],
										type: 'seek',
										frames: [0, lottiePlayer._lottie.totalFrames],
									},
								],
							});
						} else if (!isAutoplay && !isVisible) {
							create({
								mode: 'scroll',
								player: `.${ playerClass }`,
								container: `.${ containerClass }`,
								actions: [
									{
										visibility: [0.3, 1],
										type: 'playOnce',
									},
								],
							});
						}

						if (isVisible) {
							playSafely(lottiePlayer);
						}
					});
				};

				if (lottiePlayer._lottie && lottiePlayer._lottie.isLoaded) {
					handleLoaded();
				} else {
					lottiePlayer.addEventListener('load', handleLoaded);
				}
			});
		});
	}
});
